// src/pages/Home.tsx
import React from 'react';
import { Link } from 'react-router-dom';





import logo from '../assets/images/logo.png';



const Footer = () => {
  return (



<>
  {/* rts footer two area start */}
  <div className="rts-footer-two-area bg-footer-2 bg_image-1">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 pt--80 pt_sm--60 pb--50 pb_sm--60">
          <div className="footer-two-wrapper-content">
            {/* footer left start */}
            <div className="footer-left-two">
              <Link to="/" className="footer-logo">
                <img src={logo} alt="logo" />
              </Link>
              <div className="rts-social-area-one mt--30">
                <ul>
  <li>
    <a 
      href="https://www.instagram.com/manikarndigital/" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fa-brands fa-instagram" />
    </a>
  </li>
  <li>
    <a 
      href="https://wa.me/919034050507" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <i className="fa-brands fa-whatsapp" />
    </a>
  </li>
                </ul>
              </div>
            </div>
            {/* footer left end */}
            {/* footer right area start */}
            <div className="footer-right-two">
              
              {/* contact info */}
              <div className="contact-information">
                <h5 className="title">Quick Links</h5>
                <Link to="/" className="map"><i className="fa-solid fa-caret-right"></i> Home</Link>
                <Link to="/about" className="map"><i className="fa-solid fa-caret-right"></i> About Us</Link>
                <Link to="/services" className="map"><i className="fa-solid fa-caret-right"></i> Our Services</Link>
                <Link to="/blog" className="map"><i className="fa-solid fa-caret-right"></i> Blog</Link>
                <Link to="/contact" className="map"><i className="fa-solid fa-caret-right"></i> Contact Us</Link>
              </div>
              {/* contact info end */}

              {/* contact info */}
              <div className="contact-information">
                <h5 className="title">Services</h5>
                <Link to="/web-design-development" className="map"><i className="fa-solid fa-caret-right"></i> WEB DESIGN AND DEVELOPMENT</Link>
                <Link to="/digital-marketing" className="map"><i className="fa-solid fa-caret-right"></i> Digital Marketing</Link>
                <Link to="/graphic-designing" className="map"><i className="fa-solid fa-caret-right"></i> Graphic Designing</Link>
                <Link to="/hosting-support" className="map"><i className="fa-solid fa-caret-right"></i> Hosting and Support</Link>
                <Link to="/website-care" className="map"><i className="fa-solid fa-caret-right"></i> Website Care</Link>
              </div>
              {/* contact info end */}

              {/* contact info */}
              <div className="contact-information">
                <h5 className="title">Contact Info</h5>
                <a className="map">
                  #37, Village Khuddi, Ambala Cantt
                </a>
                <a href="mailto:info@manikarndigital.com" className="mail">
                  info@manikarndigital.com
                </a>
                <a href="tel:+919034050507" className="number">
                  +91-903 405 0507
                </a>
              </div>
              {/* contact info end */}
            </div>
            {/* footer right area end */}
          </div>
        </div>
        <div className="col-lg-12">
          {/* copyright-area-start */}
          <div className="copy-right-area-start-two">
            <p className="left">2025 © Manikarn Digital. All rights reserved.</p>
          </div>
          {/* copyright-area-end */}
        </div>
      </div>
    </div>
  </div>
  {/* rts footer two area end */}
</>


  );
};

export default Footer;
